import React from 'react';
import Icon from '../../../components/AppIcon';

const TopVINsWidget = ({ topVins = [], title = "VINs Más Consultados", emptyMessage = "No hay datos de consultas disponibles" }) => {
  const formatVIN = (vin) => {
    if (!vin || vin?.length !== 17) return vin;
    return `${vin?.substring(0, 3)}-${vin?.substring(3, 9)}-${vin?.substring(9)}`;
  };

  const getBrandIcon = (brand) => {
    // Return appropriate icon based on brand
    const brandIcons = {
      'Toyota': 'Car',
      'Honda': 'Car',
      'Ford': 'Truck',
      'Chevrolet': 'Car',
      'Nissan': 'Car',
      'Volkswagen': 'Car'
    };
    return brandIcons?.[brand] || 'Car';
  };

  const getPopularityColor = (index) => {
    if (index === 0) return 'text-warning'; // Gold for #1
    if (index === 1) return 'text-muted-foreground'; // Silver for #2
    if (index === 2) return 'text-warning'; // Bronze for #3
    return 'text-muted-foreground';
  };

  const getPopularityBg = (index) => {
    if (index === 0) return 'bg-warning/10';
    if (index === 1) return 'bg-muted/20';
    if (index === 2) return 'bg-warning/5';
    return 'bg-muted/10';
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-elevation">
      <div className="p-6 border-b border-border">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-foreground">{title}</h3>
          <Icon name="TrendingUp" size={16} className="text-primary" />
        </div>
      </div>
      <div className="p-6">
        {!topVins || topVins?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="Search" size={48} className="text-muted-foreground mx-auto mb-3" />
            <p className="text-muted-foreground">{emptyMessage}</p>
          </div>
        ) : (
          <div className="space-y-3">
            {topVins?.map((vinData, index) => (
              <div 
                key={vinData?.vin}
                className={`flex items-center space-x-4 p-3 rounded-lg transition-smooth hover:bg-muted/30 ${getPopularityBg(index)}`}
              >
                {/* Ranking */}
                <div className={`flex items-center justify-center w-8 h-8 rounded-full font-semibold text-sm ${
                  index < 3 ? getPopularityColor(index) : 'text-muted-foreground'
                } ${index < 3 ? 'bg-current/10' : 'bg-muted'}`}>
                  {index + 1}
                </div>

                {/* Vehicle Info */}
                <div className="flex items-center space-x-3 flex-1 min-w-0">
                  <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
                    <Icon name={getBrandIcon(vinData?.brand)} size={20} className="text-primary" />
                  </div>
                  
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center space-x-2 mb-1">
                      <p className="text-sm font-medium text-foreground truncate">
                        {vinData?.brand} {vinData?.model}
                      </p>
                      <span className="text-xs text-muted-foreground">
                        {vinData?.year}
                      </span>
                    </div>
                    <p className="text-xs font-mono text-muted-foreground">
                      {formatVIN(vinData?.vin)}
                    </p>
                  </div>
                </div>

                {/* Stats */}
                <div className="text-right">
                  <div className="flex items-center space-x-2 mb-1">
                    <Icon name="Search" size={14} className="text-muted-foreground" />
                    <span className="text-sm font-semibold text-foreground">
                      {vinData?.consultations}
                    </span>
                  </div>
                  <p className="text-xs text-muted-foreground">
                    consultas
                  </p>
                </div>

                {/* Trend Indicator */}
                <div className="flex flex-col items-center">
                  {vinData?.trend === 'up' && (
                    <Icon name="TrendingUp" size={16} className="text-success" />
                  )}
                  {vinData?.trend === 'down' && (
                    <Icon name="TrendingDown" size={16} className="text-error" />
                  )}
                  {vinData?.trend === 'stable' && (
                    <Icon name="Minus" size={16} className="text-muted-foreground" />
                  )}
                  {vinData?.trendValue && (
                    <span className={`text-xs font-medium ${
                      vinData?.trend === 'up' ? 'text-success' :
                      vinData?.trend === 'down' ? 'text-error' : 'text-muted-foreground'
                    }`}>
                      {vinData?.trendValue}
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* View All Button */}
        {topVins?.length > 0 && (
          <div className="mt-6 pt-4 border-t border-border">
            <button className="w-full text-sm text-primary hover:text-primary/80 font-medium transition-colors flex items-center justify-center space-x-2">
              <span>Ver Análisis Completo</span>
              <Icon name="ArrowRight" size={14} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TopVINsWidget;